<footer class="bg-dark text-light mt-16 border-t border-light/10">
  <div class="container mx-auto px-4 py-12">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
      <div>
        <h3 class="text-xl font-bold mb-4 text-primary">Kansino Nederland</h3>
        <p class="text-gray-400 text-sm mb-4">
          Uw betrouwbare gids voor online casino en gaming in Nederland. Wij helpen u de beste casino platforms te vinden met exclusieve bonussen en veilige spelomgevingen.
        </p>
        <div class="flex items-center space-x-2">
          <span class="bg-primary/20 border border-primary px-3 py-1 rounded text-xs font-semibold text-primary">18+</span>
          <span class="text-gray-500 text-xs">Alleen</span>
        </div>
      </div>
      
      <div>
        <h4 class="font-semibold mb-4 uppercase tracking-wider text-light/50">Navigatie</h4>
        <ul class="space-y-2 text-sm">
          <li><a routerLink="/about" class="text-gray-300 hover:text-primary transition-colors">Over Ons</a></li>
          <li><a routerLink="/contact" class="text-gray-300 hover:text-primary transition-colors">Contact</a></li>
          <li><a routerLink="/faq" class="text-gray-300 hover:text-primary transition-colors">FAQ</a></li>
          <li><a routerLink="/testimonials" class="text-gray-300 hover:text-primary transition-colors">Beoordelingen</a></li>
        </ul>
      </div>

      <div>
        <h4 class="font-semibold mb-4 uppercase tracking-wider text-light/50">Kansino Nederland</h4>
        <ul class="space-y-2 text-sm">
          <li><a routerLink="/about" class="text-gray-300 hover:text-primary transition-colors">Over Kansino Nederland</a></li>
          <li><a routerLink="/responsible-gambling" class="text-gray-300 hover:text-primary transition-colors">Verantwoord Gokken</a></li>
          <li><a routerLink="/terms" class="text-gray-300 hover:text-primary transition-colors">Algemene Voorwaarden</a></li>
          <li><a routerLink="/privacy" class="text-gray-300 hover:text-primary transition-colors">Privacybeleid</a></li>
        </ul>
      </div>

      <div>
        <h4 class="font-semibold mb-4 uppercase tracking-wider text-light/50">Contact & Ondersteuning</h4>
        <ul class="space-y-2 text-sm">
          <li class="text-gray-300">E-mail: <a href="mailto:info@kansinonederland.com" class="text-primary hover:text-orange-600 transition-colors">info@kansinonederland.com</a></li>
          <li class="text-gray-300">Website: <a href="https://kansinonederland.com" target="_blank" rel="noopener" class="text-primary hover:text-orange-600 transition-colors">kansinonederland.com</a></li>
          <li class="text-gray-400 text-xs mt-4">Reactietijd: 24 uur</li>
        </ul>
      </div>
    </div>

    <div class="border-t border-light/10 mt-8 pt-8 text-center">
      <app-regulatory-signs></app-regulatory-signs>
      <p class="text-gray-500 text-sm mt-4">
        © 2024 Kansino Nederland. Alle rechten voorbehouden.
      </p>
      <p class="text-primary font-semibold mt-2">18+ Alleen | Verantwoord Gokken</p>
    </div>
  </div>
</footer>

